<mgl-map
  [style]="'mapbox://styles/robertstadnick/cllvd0l2p006f01r6dh4j8w0s'"
  [zoom]="zoom"
  [center]="mapCenter"
  (mapCreate)="onMapReady($any($event))"
>
  @if (selectQuoteAddress$ | async; as customer) {
  <mgl-marker [lngLat]="$any(customer.location?.coordinates)">
    <div class="marker">
      <i class="bi bi-geo-fill fs-2x text-dark" ngbTooltip="$5000.00"></i>
    </div>
  </mgl-marker>
  }
</mgl-map>
